import React from 'react';

import { notification } from 'antd';

const openNotificationWithIcon = (type: string, title: string, message: any) => {
    notification[type]({
        message: title,
        description: (<ul style={{ 'padding': 0 }}>{message}</ul>),
        duration: 7.5,
    });
};

const openNotificationWithMoreDuration = (type: string, title: string, message: any) => {
    notification[type]({
        message: title,
        description: (<ul style={{ 'padding': 0 }}>{message}</ul>),
        duration: 10,
    });
};
export default class NotificationComponent {

    static Notify = (type: string, title: string, notification: any) => {
        let message: any;
        if (notification.isArray) {
            message = notification.map((err: any) => {
                return (<li style={{ 'padding': 0 }}>{err}</li>);
            })
        } else {
            message = <p> {notification} </p>
        }
        openNotificationWithIcon(type, title, message);
    }

    static NotifyWithMoreDuration = (type: string, title: string, notification: any) => {
        let message: any;
        if (notification.isArray) {
            message = notification.map((err: any) => {
                return (<li style={{ 'padding': 0 }}>{err}</li>);
            })
        } else {
            message = <p> {notification} </p>
        }
        openNotificationWithMoreDuration(type, title, message);
    }
}
